export const warehouseStates = [
  { id: 0, title: "Ожидается" },
  { id: 1, title: "К свозке" },
  { id: 2, title: "Свозка" },
  { id: 3, title: "На складе" },
  { id: 4, title: "Частично на складе" },
  { id: 5, title: "Отгружен" },
  { id: 6, title: "Запрос на удаление" },
];